import { logInfo } from "./sentryLogging";

// Origin only, so query strings never reach the logs. Keywords like "inline" pass through.
function originOf(uri: string): string {
  try {
    return new URL(uri).origin;
  } catch {
    return uri;
  }
}

/** Logs report-only CSP violations, once per directive and origin per page load. */
export function installCspReporting() {
  const seen = new Set<string>();

  document.addEventListener("securitypolicyviolation", (e) => {
    const blocked = originOf(e.blockedURI);
    const key = `${e.effectiveDirective} ${blocked}`;
    if (seen.has(key)) return;
    seen.add(key);

    logInfo("CSP violation", "security.csp_violation", {
      directive: e.effectiveDirective,
      blocked,
      source: originOf(e.sourceFile),
      disposition: e.disposition,
    });
  });

  // frame-ancestors violations are only reported to the parent, so log who frames us instead.
  if (window.top !== window.self) {
    logInfo("App loaded in a frame", "security.framed", {
      ancestor_origins: Array.from(window.location.ancestorOrigins ?? []).join(" "),
      referrer: originOf(document.referrer),
    });
  }
}
